import { render } from "./ConseilsPerruque.vue?vue&type=template&id=d50c85ae&scoped=true"
import script from "./ConseilsPerruque.vue?vue&type=script&lang=js"
export * from "./ConseilsPerruque.vue?vue&type=script&lang=js"

import "./ConseilsPerruque.vue?vue&type=style&index=0&id=d50c85ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d50c85ae"]])

export default __exports__